import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useIcons from '@/composables/useIcons'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useGamification from '@/composables/useGamification'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NewLevelCongratulationsModal',
  emits: ['exit-confetti'],
  setup(__props) {

  
  const { translateString } = useI18n()
  const { trophy } = useIcons()
  const { userStats, totalPoints, currentLevel } = useGamification()

  const currentPoints = computed(() =>
    translateString('navigation.gamificationPoints.points', { points: totalPoints.value }),
  )

  const newLevelName = computed(() => currentLevel.value?.name)

  const nextLevelName = computed(() => userStats.value?.nextLevelName)

  const nextLevelPoints = computed(() => userStats.value?.level.maximumPoints)

  const nextLevelDetails = computed(() =>
    translateString('navigation.gamificationPoints.nextLevel', {
      name: nextLevelName.value,
      points: nextLevelPoints.value,
    }),
  )

return { __sfc: true,translateString, trophy, userStats, totalPoints, currentLevel, currentPoints, newLevelName, nextLevelName, nextLevelPoints, nextLevelDetails, computed, useIcons, KetchUpButton, useGamification, useI18n }
}

})